import Velocity from 'velocity-animate';

import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './long-house.scss';
import './import/img/uus-volta-9-1-a.png';
import './import/img/uus-volta-9-1-b.png';

class Tween {

    private static DELAY: number = 1000 / 60;

    readonly duration: number;

    private current: number = 0;
    private id: number;
    private progress: number;
    private startTime: number;
    private time: number;
    private to: number;
    private from: number;
    private diff: number;
    private element: JQuery<HTMLElement>;

    constructor(element: JQuery, duration: number) {
        this.element = element;
        this.duration = duration;
    }

    private static getEase(time: number, from: number, diff: number, duration: number): number {
        const t: number = time / duration;
        const ts: number = t * t;
        const tc: number = ts * t;

        return from + diff * (0.499999999999997 * tc * ts + -2.5 * ts * ts + 5.5 * tc + -6.5 * ts + 4 * t);
    }

    private static getTime(): number {
        if (window?.performance?.now) {
            return window.performance.now();
        } else {
            if (window?.performance?.now()) {
                return window.performance.now();
            } else {
                if (Date.now) {
                    return Date.now();
                } else {
                    return new Date().getTime();
                }
            }
        }
    }

    public moveTo(to: number): void {
        this.to = to;
        this.startTime = Tween.getTime();
        this.progress = 0;
        this.from = this.current;
        this.diff = this.to - this.from;
        this.time = this.progress + Tween.DELAY;
        if (this.id) {
            this.cancel();
        }

        this.step();
    }

    public stop(): void {
        window.cancelAnimationFrame(this.id);
        this.element.removeAttr('style');
    }

    private step(): void {
        if (this.startTime) {
            this.progress = Tween.getTime() - this.startTime;
            if (this.duration > 0) {
                this.current = Tween.getEase(this.time, this.from, this.diff, this.duration);
                this.element.css('transform', 'translateX(' + Math.round(this.current) + 'px)');
            } else {
                this.element.css('transform', 'translateX(' + this.to + 'px)');
            }

            if (this.progress >= this.time) {
                this.time = (this.progress > this.time) ? this.progress + Tween.DELAY - (this.progress - this.time) : this.progress + Tween.DELAY - 1;
                if (this.time < this.progress + 1) {
                    this.time = this.progress + 1;
                }
            }
        }

        this.id = window.requestAnimationFrame(this.step.bind(this));
    }

    private cancel(): void {
        window.cancelAnimationFrame(this.id);
    }
}

export default class LongHouse extends Component {
    static initSelector: string = '.js-long-house';

    private static minWidth: number = 1024;
    private static maxWidth: number = 5000;
    private static animationSpeed: number = 800;

    readonly image: JQuery<HTMLElement>;
    readonly timer: number;

    private arrowLeft: JQuery;
    private arrowRight: JQuery;
    private position: number = 0;
    private destination: number = null;
    private imageContainer: JQuery;
    private isScrolling: boolean;
    private tween: Tween;

    constructor(target: HTMLElement) {
        super(target);

        this.arrowLeft = this.element.find('.long-house__arrow--left');
        this.arrowRight = this.element.find('.long-house__arrow--right');
        this.image = this.element.find('.long-house__image-container');
        this.imageContainer = this.image.parent();
        this.tween = new Tween(this.image, LongHouse.animationSpeed);

        if (Helpers.isMobileDevice) {
            this.arrowRight.on('click', this.onRightClick.bind(this));
            this.arrowLeft.on('click', this.onLeftClick.bind(this));
        } else {
            this.element.on('mouseleave', this.onMouseLeave.bind(this));
            this.element.on('mousemove MSPointerMove pointermove', this.onMove.bind(this));
            this.timer = window.setInterval(this.move.bind(this), 16.6);
        }
    }

    private onRightClick(): void {
        const newOffset: number = this.imageContainer.scrollLeft() + screen.width * .75;

        this.scroll(newOffset);
    }

    private onLeftClick(): void {
        const newOffset: number = this.imageContainer.scrollLeft() - screen.width * .75;

        this.scroll(newOffset);
    }

    private scroll(offset: number): void {
        if (!this.isScrolling) {
            Velocity(this.image, 'scroll', {
                axis: 'x',
                begin: this.onScrollBegin.bind(this),
                complete: this.onScrollComplete.bind(this),
                container: this.imageContainer,
                duration: LongHouse.animationSpeed / 2,
                offset,
            });
        }
    }

    private onScrollBegin(): void {
        this.isScrolling = true;
    }

    private onScrollComplete(): void {
        this.isScrolling = false;
    }

    private onMove(event: JQuery.TriggeredEvent, point: boolean): void {
        event.preventDefault();
        const isTouch: boolean = event.type.indexOf('touch') !== -1;
        const isPointer: boolean = event.type.indexOf('pointer') !== -1;
        const pageX: number = (isPointer ? (event.originalEvent as PointerEvent).pageX : (isTouch ? event.touches[0].pageX || event.changedTouches[0].pageX : event.pageX));
        const position: number = (!point ? (pageX - this.element.offset().left) : this.element.width() / 2);

        this.destination = this.getDestination(position);
        this.position = position;
    }

    private onMouseLeave(): void {
        this.destination = null;
    }

    private getDestination(position: number): number {
        const width: number = this.element.width();

        if (this.position >= this.element.width()) {
            return this.element.width();
        } else if (this.position <= 0) {
            return 0;
        } else {
            return -Math.round((this.image.outerWidth(true) - width) * (position / width));
        }
    }

    private move(): void {
        if (this.element.parents('html').length) {
            if ($(window).width() > LongHouse.minWidth && $(window).width() <= LongHouse.maxWidth) {
                if (this.destination !== null) {
                    this.tween.moveTo(this.destination);
                } else {
                    this.tween.moveTo(this.getDestination(this.position));
                }
            } else {
                this.tween.stop();
            }
        } else if (this.timer) {
            window.clearInterval(this.timer);
        }
    }
}

if (!window.requestAnimationFrame) {
    let lastTime: number;

    window.requestAnimationFrame = (callback: FrameRequestCallback): number => {
        const currTime: number = new Date().getTime();
        const timeToCall: number = Math.max(0, 16 - (currTime - lastTime));
        const id: number = window.setTimeout(() => {
            callback(currTime + timeToCall);
        }, timeToCall);

        lastTime = currTime + timeToCall;

        return id;
    };
}

if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = (id: number): void => {
        clearTimeout(id);
    };
}
